import { useContext, useEffect, useState } from "react";

import { EncryptionContext } from "@swa-ui/encryption";

import { createHrefWithEncryptedSearchParams } from "../createHrefWithEncryptedSearchParams";
import { createHrefWithSearchParams } from "../createHrefWithSearchParams";
import { containsParamsToEncrypt } from "../encryption/encryption";

/**
 * Generates a new href with a base path and a search params object. The function automatically
 * encodes special characters to query safe values.
 * @param {string} basePath The base of the HREF to create
 * @param {object} searchParams The search parameters that should be included in the HREF
 * @param {ObjectSchema} validations A set of yup validations to validate the search parameters
 * @returns {string} An href with the combined base path and search parameters
 */
export const useHrefWithSearchParams = (
  basePath,
  searchParams,
  validations,
  component,
  feature
) => {
  const encryptionContext = useContext(EncryptionContext);
  const [results, setResults] = useState({ errors: [], href: "" });

  useEffect(() => {
    const createAndSetEncryptedHref = async () => {
      const encryptedResults = await createHrefWithEncryptedSearchParams(
        basePath,
        searchParams,
        validations,
        encryptionContext,
        component,
        feature
      );

      setResults(encryptedResults);
    };

    if (containsParamsToEncrypt(searchParams)) {
      if (encryptionContext) {
        createAndSetEncryptedHref();
      } else {
        console.warn(
          "Attempting to encrypt search params without providing an encryption context."
        );
      }
    } else {
      setResults(createHrefWithSearchParams(basePath, searchParams, validations));
    }
  }, [encryptionContext]);

  return results;
};
